import { Injectable, inject } from '@angular/core';
import {
  VALIDATOR_NAME,
  TRANSLATION_KEY,
} from '@iris/common/modules/fields/validation/validators/no-leading-digit.validator';
import { ValidationMessageResolver } from '@ngx-strakit/validation';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SkNoLeadingDigitValidationMessageResolver implements ValidationMessageResolver {
  private readonly translate = inject(TranslateService);

  readonly errorCode = VALIDATOR_NAME;

  getMessage(): string {
    return this.translate.instant(TRANSLATION_KEY);
  }
}
